import React from "react";
import { Layout, Typography, Row, Col, Divider, ConfigProvider } from "antd";
import { Image } from 'antd';
import { BreadCrumbs } from "../../Components/Layout/BreadCrumbs";
import Page from "../../Components/Page/Page";
import { TextService } from "../../Services/TextService";
const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;


const MemberSystemIntegrations: React.FC = () => {
    const GetText = TextService.GetText;

    return (
        <Layout style={{ background: "#fff" }}>
            <Content>
                <ConfigProvider
                    theme={{
                        components: {
                            Typography: {
                                fontSize: 18,
                                lineHeight: 1.7,
                            },
                        },
                    }}
                >
                    <Page pageTitle={GetText("PageTitle_Integrations")} metaDescription="Integrera ditt medlemsregister med Fortnox, Spiris och betallösningar. OneFront360 kopplar ihop dina system.">

                        <Typography>

                            <div className="article-block">
                                <div className="article-inner">
                                    <div
                                        style={{
                                            background: "#f0f5ff",
                                            padding: "80px 24px",
                                            borderRadius: 12,
                                            marginBottom: 48,
                                        }}
                                    >
                                        <Row gutter={[32, 32]} align="middle">
                                            <Col xs={24} md={14}>

                                                <BreadCrumbs />


                                                <Title style={{ fontSize: 42, fontWeight: 700, marginBottom: 24 }}>
                                                    Betalintegrationer för föreningar – automatiserat, säkert och helt utan manuellt arbete
                                                </Title>

                                                <Paragraph style={{ fontSize: 18, marginBottom: 32 }}>
                                                    OneFront360 erbjuder smarta betalintegrationer som gör det enkelt för föreningar att ta emot
                                                    medlemsavgifter, eventbetalningar och andra transaktioner. Med stöd för Swish, kort och faktura
                                                    via Ping Payments – och full synk mot Fortnox – får ni en automatiserad och trygg betalningsprocess
                                                    som sparar tid och minskar risken för fel.
                                                </Paragraph>
                                            </Col>

                                            <Col xs={24} md={10}>
                                                <Image
                                                    src={require('../../Images/Articles/betalintegrationer.png')}
                                                    preview={false}
                                                    style={{ borderRadius: 12, width: '100%' }}
                                                />
                                            </Col>
                                        </Row>
                                    </div>


                                </div></div>

                            <div className="article-block">
                                <div className="article-inner">

                                    <Paragraph>
                                        Smarta integrationer är en av de viktigaste delarna i ett modernt medlemssystem. När dina verktyg pratar med varandra slipper du dubbelarbete, manuella rutiner och risken för fel. OneFront360 erbjuder kraftfulla integrationer som kopplar ihop ditt medlemssystem med hemsida, betalningslösningar och ekonomisystem – allt för att förenkla vardagen för både kassörer, administratörer och medlemmar.
                                    </Paragraph>

                                    <Divider />

                                    <Title level={2}>Smarta integrationer för en effektivare förening</Title>
                                    <Paragraph>
                                        Genom att koppla ihop OneFront360 med dina befintliga system kan du automatisera viktiga delar av föreningens administration. Det innebär att information uppdateras automatiskt, betalningar registreras direkt och ekonomin hålls i perfekt synk – utan att du behöver göra något manuellt.
                                    </Paragraph>
                                    <ul>
                                        <li><Text>Integrera med hemsidan för smidiga medlemsregistreringar</Text></li>
                                        <li><Text>Automatisera medlemsinbetalningar via Ping Payments</Text></li>
                                        <li><Text>Synkronisera ekonomi och fakturor med Fortnox</Text></li>
                                        <li><Text>Slipp dubbelarbete och manuella uppdateringar</Text></li>
                                    </ul>
                                    <Paragraph>
                                        Med rätt integrationer blir OneFront360 navet i föreningens digitala ekosystem.
                                    </Paragraph>

                                </div></div>
                            <Divider />

                            <div className="article-grey-block">
                                <div className="article-inner">
                                    <Title level={2}>Ping Payments – automatiserade och säkra betalningar</Title>
                                    <Paragraph>
                                        OneFront360 har en direkt integration med <Text strong>Ping Payments</Text>, en svensk betalningsplattform som är utvecklad för organisationer och föreningar. Genom integrationen kan du ta emot medlemsavgifter och eventbetalningar via Swish, kort eller faktura – helt automatiserat.
                                    </Paragraph>
                                    <ul>
                                        <li><Text>Betalningar registreras automatiskt i medlemsregistret</Text></li>
                                        <li><Text>Stöd för Swish, kort och faktura</Text></li>
                                        <li><Text>Betalningspåminnelser</Text></li>
                                        <li><Text>Full överblick över betalda och obetalda avgifter</Text></li>
                                    </ul>
                                    <Paragraph>
                                        Integrationen med Ping Payments gör att kassören sparar tid, minskar risken för fel och får en tydlig översikt över föreningens ekonomi.
                                    </Paragraph>
                                </div>
                            </div>
                            <Divider />


                            <div className="article-block">
                                <div className="article-inner">
                                    <Title level={2}>Fortnox – sömlös synk av ekonomi och bokföring</Title>
                                    <Paragraph>
                                        För föreningar som använder <Text strong>Fortnox</Text> erbjuder OneFront360 en kraftfull integration som automatiskt synkroniserar fakturor, betalningar och ekonomiska transaktioner. Det innebär att du slipper dubbelregistrering och alltid har korrekt bokföringsunderlag.
                                    </Paragraph>
                                    <ul>
                                        <li><Text>Automatisk överföring av fakturor och betalningar</Text></li>
                                        <li><Text>Uppdaterad status på medlemsavgifter</Text></li>
                                        <li><Text>Mindre administration och färre fel</Text></li>
                                    </ul>
                                    <Paragraph>
                                        Integrationen gör att ekonomiarbetet blir både snabbare och mer tillförlitligt – perfekt för föreningar som vill ha full kontroll.
                                    </Paragraph>
                                </div></div>


                            <div className="article-grey-block">
                                <div className="article-inner">

                                    <Title level={2}>
                                        Koppla ihop din hemsida – smidiga flöden för medlemmar
                                    </Title>
                                    <Paragraph>
                                        Med OneFront360 kan du enkelt koppla ihop ditt medlemssystem med föreningens hemsida. Nya medlemmar kan registrera sig online, anmäla sig till aktiviteter och betala direkt – och all information hamnar automatiskt i systemet.
                                    </Paragraph>
                                    <Paragraph>Med OneFront360 får du:</Paragraph>
                                    <ul>
                                        <li><Text>Medlemsregistrering direkt på hemsidan</Text></li>
                                        <li><Text>Automatisk import till medlemsregistret</Text></li>
                                        <li><Text>Integrerara eventanmälningar direkt på hemsidan</Text></li>
                                        <li><Text>Mindre administration för föreningen</Text></li>
                                    </ul>
                                    <Paragraph>
                                        Det skapar en smidig upplevelse för medlemmarna och sparar tid för administratörer.
                                    </Paragraph>

                                </div></div>

                            <div className="article-block">
                                <div className="article-inner">

                                    <Title level={2}>En plattform som växer med föreningen</Title>
                                    <Paragraph>
                                        OneFront360s integrationer gör att du kan bygga ett komplett digitalt ekosystem för föreningen. Oavsett om du vill automatisera betalningar, förenkla bokföringen eller skapa smidiga medlemsflöden är systemet redo att växa med dina behov.
                                    </Paragraph>

                                </div>
                            </div>



                        </Typography>
                    </Page>
                </ConfigProvider>
            </Content >
        </Layout >
    );
};

export default MemberSystemIntegrations;
